import React, { Component } from "react";
import { Redirect } from 'react-router-dom';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'underscore';
import { Toast } from '../Notification';

import ApprovalFindByResourceCollectionForm from './ApprovalFindByResourceCollectionForm';
import ApprovalFindByResourceForm from './ApprovalFindByResourceForm';
import ApprovalFindByBranchDivisionCostCenterForm from './ApprovalFindByBranchDivisionCostCenterForm';
import ApprovalFindByCostObject from './ApprovalFindByCostObject';
import * as approvalActions from '../../redux/actions/approvalActions';
import * as liveScheduleActions from '../../redux/actions/liveScheduleActions';
import * as resourceActions from '../../redux/actions/resourceActions';
import Spinner from '../Theme/Spinner';

const lodash = require('lodash');
const timezone = 'UTC'; //Should be set to the timezone of the server, since amplify is on the cloud it uses UTC

class ApprovalFindUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearching: false,
      resourceCollection: this.props.resourceCollection,
      resourceCollectionList: this.props.resourceCollectionList,
      filteredResourceCollectionList: this.props.resourceCollectionList,
      contextMenuKey: this.props.contextMenuKey || 1,
      resource: this.props.selectedResource,
      requestDates: {
        fromDate: moment(),
        toDae: moment(),
      },
      redirectToApprovalView: false,
      showFilteredResources: false,
      resources: [],
      selectedResource: {},
      branchId: 0,
      divisionId: 0,
      costCenterId: 0,
      branchOptions: [
        { id: null, name: '' }
      ],
      divisionOptions: [
        { id: null, name: '' }
      ],
      costCenterOptions: [
        { id: null, name: '' }
      ],
      showCostObjectModal: false,
      costObject: {}
    }
  }

  componentDidMount() {
    this.checkResource();
    this.getBranchOptions();
  }

  componentWillReceiveProps({ contextMenuKey }) {
    this.checkResource();
    this.setState({
      contextMenuKey
    });
  }

  checkResource = () => {
    let resource;
    if (!this.state.resource.id && !this.state.resource.name) {
      resource = {
        id: this.props.user.login.resourceId,
        name: this.props.user.userDemographics.name
      }
      this.setState({
        resource
      });
    }
  }

  getResourceCollections = async () => {
    const userId = this.props.user.login.id || null;

    if (userId) {
      await this.props.actions.fetchListOfResourceCollection(userId);
    }
  }

  handleFromDateChange = (value, callback) => {
    const { requestDates } = this.state;
    requestDates.fromDate = value;

    this.setState({
      requestDates
    }, () => { callback() });
  }

  handleToDateChange = (value, callback) => {
    const { requestDates } = this.state;
    requestDates.toDate = value;

    this.setState({
      requestDates
    }, () => { callback() });
  }

  handleResourceCollectionChange = (e, record) => {
    this.setState({
      resourceCollection: {
        resourceCollectionId: record.id,
        resourceCollectionName: record.name
      }
    }, () => {
      console.log(this.state.resourceCollection)
    });
    return ''
  }

  handleResourceCollectionSearch = async event => {
    const searchValue = event.target.value
    if (searchValue && searchValue !== '') {
      this.setState({ showFilteredResources: true });
    } else this.setState({ showFilteredResources: false });

    let filteredArray = [];

    if (this.state.resourceCollectionList && this.state.resourceCollectionList.length > 0) {
      const collectionListCopy = lodash.cloneDeep(this.state.resourceCollectionList);
      filteredArray = collectionListCopy.filter((value) => {
        if (value && value.name && value.name.toLowerCase().includes(searchValue.toLowerCase())) {
          return value;
        }
        return null;
      });
    }

    this.setState({
      filteredResourceCollectionList: filteredArray
    });
  }

  // BY RESOURCE
  handleResourceSearch = async (name, sso) => {
    const ssoRegex = /\d+/;
    const nameRegex = /\w+/;
    name = `%${name}%`;
    let testName = name.substring(1, name.length - 1);
    if ((sso && ssoRegex.test(sso)) || (testName && nameRegex.test(testName))) {
      await this.props.actions.fetchFindResource(name, sso).catch(error => {
        alert("Loading resources failed\n" + JSON.stringify(error));
      });
      this.setState({
        resources: this.props.resources.resources
      });
    } else if (!testName && !sso) {
      this.setState({
        resources: []
      });
    }
  }

  handleSelectResource = (resource) => {
    this.setState({
      selectedResource: resource
    }, () => {
      console.log(this.state.selectedResource)
    });
  }

  // BY COST CENTER
  getBranchOptions = async () => {
    await this.props.actions.fetchBranches({ companyId: 1 });

    this.setState({
      branchOptions: this.props.branches
    });
  }

  getDivisionOptions = async (branch) => {
    console.log("getting division options with branch ID: " + branch);
    await this.props.actions.fetchDivisions({ branchId: branch });

    this.setState({
      divisionOptions: this.props.divisions,
      branchId: branch
    });
  }

  getDepartmentOptions = async (division) => {
    console.log("getting department options with division ID: " + division);
    await this.props.actions.fetchDepartments(
      {
        companyId: 1,
        branchId: this.state.branchId,
        divisionId: division,
        withCBCode: false
      }
    );

    this.setState({
      costCenterOptions: this.props.departments,
      costCenterId: division
    });
  }

  // BY COST OBJECT
  handleShowCostObjectModalOpen = () => {
    this.setState({
      showCostObjectModal: true
    });
  }

  handleShowCostObjectModalCancel = () => {
    this.setState({
      showCostObjectModal: false
    });
  }

  handleSelectCostObject = (record) => {
    this.setState({
      costObject: record
    });
  }

  searchBy = async (formValues, by) => {
    this.setState({
      isSearching: true
    })

    const parameters = this.composeParameters(formValues, by);

    let notification = { type: 'success', message: 'Searching for Approvals Success' };

    //store parameters in store for the approval screen
    await this.props.actions.updateApprovalParameters(lodash.cloneDeep(parameters));

    try {
      await this.props.actions.fetchTourApprovals(parameters);
    }
    catch (error) {
      this.setState({
        isSearching: false
      })
      if (!_.isEmpty(error)) {
        notification = {
          type: 'error',
          message: "Searhing for Approvals failed",
          description: error.errors[0].message.includes('->') ? error.errors[0].message.split('->')[1] : error.errors[0].message
        };
      }
    }
    Toast(notification);
    if (notification.type !== 'error') {
      //redirect to approval view
      this.setState({
        redirectToApprovalView: true,
        isSearching: false
      });
    }
  }

  composeParameters = (data, findBy) => {
    const parameters = {
      fromDate: '',
      tillDate: '',
      branchId: 0,
      divisionId: 0,
      departmentId: 0,
      by: 2,
      rcId: 0,
      filter: '',
      orderBy: 2,
      jobId: 0,
      resourceId: 0,
      userId: this.props.user.login.id,
      showAssignments: false,
      orderByDep: false,
      clientId: 0,
      projectId: 0,
      showDayTypes: false,
      costObjectId: 0,
      costObjectTypeId: 0,
    };

    switch (findBy) {
      case 'resourceCollection':
        parameters.fromDate = data.fromDate.format('YYYY-MM-DD 00:00:00.0')
        parameters.tillDate = data.toDate.format('YYYY-MM-DD 00:00:00.0')
        parameters.filter = data.filter;
        parameters.orderBy = data.sortOrder;
        parameters.orderByDep = data.sortByCostObject || false;

        parameters.rcId = data.selectedResourceCollection.resourceCollectionId
        console.log(parameters)
        break;
      case 'resource':
        parameters.by = 4;
        parameters.fromDate = data.fromDate.format('YYYY-MM-DD 00:00:00.0')
        parameters.tillDate = data.toDate.format('YYYY-MM-DD 00:00:00.0')
        parameters.filter = data.filter;
        parameters.orderBy = 2; // date
        parameters.orderByDep = data.sortByCostObject || false;

        parameters.resourceId = data.selectedResource.id
        parameters.departmentId = data.selectedResource.costCenterId;
        console.log(parameters)
        break;
      case 'branchDivisionDepartment':
        parameters.by = 1;
        parameters.fromDate = data.fromDate.format('YYYY-MM-DD 00:00:00.0')
        parameters.tillDate = data.toDate.format('YYYY-MM-DD 00:00:00.0')
        parameters.filter = data.filter;
        parameters.orderBy = data.sortOrder;
        parameters.orderByDep = data.sortByCostObject || false;

        parameters.branchId = data.branch;
        parameters.divisionId = data.division;
        parameters.departmentId = data.costCenter;
        console.log(parameters)
        break;
      case 'costObject':
        parameters.by = 6;
        parameters.fromDate = data.fromDate.format('YYYY-MM-DD 00:00:00.0')
        parameters.tillDate = data.toDate.format('YYYY-MM-DD 00:00:00.0')
        parameters.filter = data.filter;
        parameters.orderBy = data.sortOrder;
        parameters.orderByDep = data.sortByCostObject || false;

        parameters.costObjectId = data.costObject.id;
        parameters.costObjectTypeId = data.costObject.costObjectType === 'COST_CENTER' ? 2 : 1;
        console.log(parameters);
        break;
      default: break;
    }

    return parameters
  }

  formByContextMenuKey = () => {
    switch (this.state.contextMenuKey) {
      case 1:
        return (
          <React.Fragment>
            <ApprovalFindByResourceCollectionForm
              handleFromDateChange={this.handleFromDateChange}
              handleToDateChange={this.handleToDateChange}
              handleResourceCollectionChange={this.handleResourceCollectionChange}
              handlefilterChange={this.handlefilterChange}
              handleShowDayTypeChange={this.handleShowDayTypeChange}
              handleSortOrderChange={this.handleSortOrderChange}
              handleSubmit={this.handleSubmit}
              handleResourceCollectionSearch={this.handleResourceCollectionSearch}
              requestDates={this.state.requestDates}
              resourceCollection={this.state.resourceCollection}
              resourceCollectionList={this.state.filteredResourceCollectionList}
              searchByResourceCollection={this.searchBy}
            />
          </React.Fragment>

        )
      case 2:
        return (
          <React.Fragment>
            <ApprovalFindByResourceForm
              handleFromDateChange={this.handleFromDateChange}
              handleToDateChange={this.handleToDateChange}
              handleResourceSearch={this.handleResourceSearch}
              handleSelectResource={this.handleSelectResource}
              resources={this.state.resources}
              selectedResource={this.state.selectedResource}
              requestDates={this.state.requestDates}
              searchByResource={this.searchBy}
            />
          </React.Fragment>
        )
      case 3:
        return (
          <React.Fragment>
            <ApprovalFindByBranchDivisionCostCenterForm
              handleFromDateChange={this.handleFromDateChange}
              handleToDateChange={this.handleToDateChange}
              requestDates={this.state.requestDates}
              branchOptions={this.state.branchOptions}
              divisionOptions={this.state.divisionOptions}
              costCenterOptions={this.state.costCenterOptions}
              getDivisionOptions={this.getDivisionOptions}
              getDepartmentOptions={this.getDepartmentOptions}
              searchByBranchDivisionDepartment={this.searchBy}
            />
          </React.Fragment>
        )
      case 4:
        return (
          <React.Fragment>
            <ApprovalFindByCostObject
              handleFromDateChange={this.handleFromDateChange}
              handleToDateChange={this.handleToDateChange}
              handleShowCostObjectModalCancel={this.handleShowCostObjectModalCancel}
              handleShowCostObjectModalOpen={this.handleShowCostObjectModalOpen}
              handleSelectCostObject={this.handleSelectCostObject}
              requestDates={this.state.requestDates}
              showCostObjectModal={this.state.showCostObjectModal}
              costObject={this.state.costObject}
              searchByCostObject={this.searchBy}
            />
          </React.Fragment>
        )
      default:
        return (
          <React.Fragment>
            <p>1</p>
          </React.Fragment>
        )
    }
  }

  render() {
    return !this.state.redirectToApprovalView ?
      (
        <React.Fragment>
          {this.state.isSearching ? (
            <Spinner />
          )
            :
            (
              <React.Fragment>
                {this.formByContextMenuKey()}
              </React.Fragment>
            )
          }
        </React.Fragment>
      )
      :
      (
        <Redirect
          to={'/approvals'}
        />
      )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    resources: state.resources,
    selectedResource: state.selectedResource,
    resourceCollectionList: state.listResourceCollections.resources,
    branches: state.branchesByCompanyId.data,
    divisions: state.divisionsByBranchId.data,
    departments: state.departmentsByCompanyIdBranchIdDivisionId.data
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchListOfResourceCollection: bindActionCreators(
        liveScheduleActions.fetchListOfResourceCollection,
        dispatch
      ),
      fetchFindResource: bindActionCreators(
        resourceActions.fetchFindResource,
        dispatch
      ),
      fetchBranches: bindActionCreators(
        approvalActions.fetchBranchesByCompanyId,
        dispatch
      ),
      fetchDivisions: bindActionCreators(
        approvalActions.fetchDivisionsByBranchId,
        dispatch
      ),
      fetchDepartments: bindActionCreators(
        approvalActions.fetchDepartmentsByCompanyIdBranchIdDivisionId,
        dispatch
      ),
      fetchTourApprovals: bindActionCreators(
        approvalActions.fetchTourApprovals,
        dispatch
      ),
      updateApprovalParameters: bindActionCreators(
        approvalActions.updateApprovalParameters,
        dispatch
      ),
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ApprovalFindUpdate);


// WEBPACK FOOTER //
// ./src/Components/Approval/ApprovalFindUpdate.js